import React from 'react';
import PropTypes from 'prop-types';
import {Breadcrumb} from 'antd';
import {ArrowLeftOutlined} from '@ant-design/icons';

import './index.less';

/**
 * antd 4 PageHeader 兼容组件。
 *
 * antd 5 移除了 PageHeader，此组件按 antd 4 的核心行为重写，
 * 支持业务中实际使用的属性：title / subTitle / extra / breadcrumb /
 * onBack / backIcon / className / style / footer / children。
 */
export default function PageHeader({
    title,
    subTitle,
    extra,
    breadcrumb,
    onBack,
    backIcon,
    className,
    style,
    footer,
    children,
}) {
    const showBack = onBack || backIcon;

    let breadcrumbEl = null;
    if (breadcrumb) {
        // 兼容 antd 4 的 {routes, itemRender} 用法
        const {routes, itemRender} = breadcrumb;
        if (Array.isArray(routes) && routes.length > 0) {
            breadcrumbEl = (
                <Breadcrumb className="bi-page-header-breadcrumb">
                    {routes.map((route, i) => (
                        <Breadcrumb.Item key={route.path || i}>
                            {itemRender
                                ? // antd 4 PageHeader 的 itemRender 签名：(route, params, routes, paths)
                                  // 兼容组件把第 2 参留空、第 3 参传完整 routes 数组，业务代码才能正确取到 routes
                                  itemRender(route, {}, routes, i)
                                : route.breadcrumbName}
                        </Breadcrumb.Item>
                    ))}
                </Breadcrumb>
            );
        }
    }

    return (
        <div className={`bi-page-header ${className || ''}`} style={style}>
            {breadcrumbEl}

            <div className="bi-page-header-heading">
                <div className="bi-page-header-heading-left">
                    {showBack && (
                        <div
                            className="bi-page-header-back"
                            role="button"
                            tabIndex={0}
                            onClick={onBack}
                            onKeyDown={e => {
                                if (e.key === 'Enter' && onBack) onBack(e);
                            }}
                        >
                            {backIcon || <ArrowLeftOutlined />}
                        </div>
                    )}
                    {title && <span className="bi-page-header-heading-title">{title}</span>}
                    {subTitle && <span className="bi-page-header-heading-sub-title">{subTitle}</span>}
                </div>
                {extra && <div className="bi-page-header-heading-extra">{extra}</div>}
            </div>

            {(footer || children) && <div className="bi-page-header-footer">{footer || children}</div>}
        </div>
    );
}

PageHeader.propTypes = {
    title: PropTypes.node,
    subTitle: PropTypes.node,
    extra: PropTypes.node,
    breadcrumb: PropTypes.shape({
        routes: PropTypes.array,
        itemRender: PropTypes.func,
    }),
    onBack: PropTypes.func,
    backIcon: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    footer: PropTypes.node,
    children: PropTypes.node,
};
